(() => {
  const init = (root = document) => {
    root.querySelectorAll('.pg-help-nav').forEach((nav) => { if (!nav.dataset.pgReady) { if (window.matchMedia('(max-width:749px)').matches) nav.open = false; nav.dataset.pgReady = 'true'; } });
    root.querySelectorAll('[data-pg-legal-headings]').forEach((copy) => {
      copy.querySelectorAll('p').forEach((paragraph) => {
        const text = paragraph.textContent.trim();
        const emphasis = paragraph.querySelector('strong,b,em');
        if (text.length < 140 && emphasis && emphasis.textContent.trim() === text) {
          const heading = document.createElement(emphasis.tagName === 'EM' ? 'h3' : 'h2'); heading.textContent = text; paragraph.replaceWith(heading);
        }
      });
      const toc = copy.parentElement.querySelector('.pg-auto-toc');
      if (toc && !toc.dataset.pgReady) {
        copy.querySelectorAll('h2,h3').forEach((heading, index) => {
          if (!heading.id) heading.id = `pg-policy-${index + 1}`;
          const li = document.createElement('li'); const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent; li.append(link); toc.querySelector('ol').append(li);
        });
        toc.hidden = !toc.querySelector('li'); toc.dataset.pgReady = 'true';
      }
    });
    root.querySelectorAll('.pg-article-toc').forEach((toc) => {
      if (toc.dataset.pgReady) return;
      const content = toc.parentElement; const headings = content.querySelectorAll('h2,h3');
      Array.from(headings).filter((h) => !toc.contains(h)).forEach((h, i) => {
        if (!h.id) h.id = `pg-article-section-${i + 1}`;
        const li = document.createElement('li'); const a = document.createElement('a'); a.textContent = h.textContent; a.href = `#${h.id}`; li.append(a); toc.querySelector('ol').append(li);
      });
      toc.hidden = toc.querySelectorAll('li').length < 3; toc.dataset.pgReady = 'true';
    });
    root.querySelectorAll('[data-pg-withdrawal]').forEach((wrapper) => {
      const form = wrapper.closest('form'); if (!form || form.dataset.pgReady) return;
      const review = wrapper.querySelector('.pg-withdrawal-review'); const start = wrapper.querySelector('[data-pg-review]');
      start.addEventListener('click', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const values = review.querySelector('[data-pg-review-values]'); values.replaceChildren();
        form.querySelectorAll('input:not([type="hidden"]),textarea').forEach((input) => {
          const label = form.querySelector(`label[for="${input.id}"]`); if (!label || !input.value) return;
          const dt = document.createElement('dt'); const dd = document.createElement('dd'); dt.textContent = label.textContent; dd.textContent = input.value; values.append(dt, dd);
        });
        review.hidden = false; start.hidden = true; review.focus();
      });
      form.addEventListener('submit', (event) => {
        // Enter and third-party form hooks must never skip the customer's review step.
        if (review.hidden || !event.submitter?.hasAttribute('data-pg-confirm')) event.preventDefault();
      });
      form.addEventListener('input', () => { if (!review.hidden) { review.hidden = true; start.hidden = false; } });
      wrapper.querySelector('[data-pg-edit]').addEventListener('click', () => { review.hidden = true; start.hidden = false; form.querySelector('input:not([type="hidden"])').focus(); });
      form.dataset.pgReady = 'true';
    });
  };
  window.matchMedia('(max-width:749px)').addEventListener('change', (event) => { document.querySelectorAll('.pg-help-nav').forEach((nav) => { nav.open = !event.matches; }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
